@if (windowService?.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container">
      <tidy-image
        [src]="'assets/svg/arrow-back-white.svg'"
        (action)="goBack()"
        class="desktop-back-icon" />
      <tidy-text
        [title]="'Recurring Maintenance'" />
      <form [formGroup]="form" novalidate action="#" class="form-filters">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search"/>
      </form>
      <tidy-small-button
        [text]="'Filter'"
        [image]="'assets/img/filter-white.svg'"
        [matMenuTriggerFor]="menu"
        [matMenuTriggerData]="{closeDisabled: true}" />
      <tidy-small-button
        [text]="'Add Recurring Maintenance'"
        [image]="'assets/img/add-white.svg'"
        (buttonClick)="addMaintenance()" />
      @for (chip of chips; track chip) {
        <ion-chip class="filter-chip">
          @if (chip.icon) {
            <mat-icon
              class="chip-icon"
              [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
          }
          <ion-label>{{ chip.name | titlecase }}</ion-label>
          <ion-icon name="close-circle" (click)="removeChip(chip)" />
        </ion-chip>
      }
    </div>
  </tidy-desktop-header>
}

@if (!windowService?.isDesktopRes) {
  <div class="mobile-nav-search issues-mobile-container" style="display: flex; align-items: center;">
    <form [formGroup]="form" novalidate action="#" style="flex: 1;">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search" />
    </form>
    <div style="display: flex; gap: 10px; margin-left: 10px;">
      <tidy-small-button
        [image]="'assets/img/filter-white.svg'"
        [disabled]="!loaded"
        [matMenuTriggerFor]="menu"
        [matMenuTriggerData]="{closeDisabled: true}"
        [iconOnly]="true" />
      <tidy-small-button
        [text]="'Add'"
        [image]="'assets/img/add-white.svg'"
        [disabled]="!loaded"
        (buttonClick)="addMaintenance()" />
    </div>
  </div>
  @if (chips?.length) {
    <div class="mobile-filter-chips">
      @for (chip of chips; track chip) {
        <ion-chip class="filter-chip">
          @if (chip.icon) {
            <mat-icon
              class="chip-icon"
              [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
          }
          <ion-label>{{ chip.name | titlecase }}</ion-label>
          <ion-icon name="close-circle" (click)="removeChip(chip)" />
        </ion-chip>
      }
    </div>
  }
}

<mat-menu #menu="matMenu" class="filter-menu">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
        <mat-checkbox
          class="checkbox"
          [checked]="getNodeChecked(node)"
          (click)="$event.stopPropagation()"
          (change)="checkNode(node, $event)">
          {{ node.name | titlecase }}
        </mat-checkbox>
      </button>
    </mat-tree-node>
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding>
      <button
        class="node-button-padding"
        mat-menu-item
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        {{ node.name | titlecase }}
      </button>
    </mat-tree-node>
  </mat-tree>
</mat-menu>
